<template>
<div class="animated fadeIn mt-3 dashboard">
  <b-card no-body class="objective-cards" v-if="$auth.check(['dashboard.objectives'])">
    <b-card-header>
      Objectivos
      <span class="float-right form-inline"><b-form-select v-model="zone" :options="objectivesZones" class="mr-2" size="sm" /> 
        <b-form-select v-model="selectedPeriod" :options="objectivesPeriods" class="mr-2" size="sm" /> 
        <b-form-select v-model="selectedMonth" :options="monthOptions" class="" size="sm" />
      </span>
    </b-card-header>

    <b-card-body>
      <b-row>
        <b-col sm="12" lg="6" xl="5">
          <objectives-table :items="mpgObjectives.liters" :per-page="0" :fields="objectiveFieldsWithQT" :show-remaining="true" table-caption="Litros / Gama" symbol=""></objectives-table>
        </b-col>
        <b-col sm="12" lg="6" xl="4">
          <objectives-table :items="mpgObjectives.gsv" :per-page="0" :fields="objectiveFieldsWithQT" table-caption="GSV / Gama" symbol="€"></objectives-table>
        </b-col>
        <b-col sm="12" lg="6" xl="3">
          <objectives-table :items="mpgObjectives.operators6" :per-page="0" :fields="objectiveFieldsWithBalance"  :show-remaining="true"  table-caption="LEs com compra >=6 / Gama" symbol=""></objectives-table>
        </b-col>
        <b-col sm="12" lg="6" xl="3" v-if="false">
          <objectives-table :items="mpgObjectives.operators" :per-page="0" :fields="objectiveFields"table-caption="LEs com compra / Gama" symbol=""></objectives-table>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
  <b-row v-if="$auth.check(['dashboard.accounts'])" >
    <b-col lg="3">
      <b-card :no-body="true">
        <div class="card-body p-3 clearfix">
          <i class="fa fa-calculator bg-secondary font-2xl p-3 mr-3 float-left"></i>
          <div class="h5 mb-0 mt-2">{{ accounts.sold | currency({fractionCount:0,symbolPosition:'back'}) }}</div>
          <div class="text-muted text-uppercase font-weight-bold font-xs">faturado últimos 30 dias</div>
        </div>
      </b-card>
    </b-col>
    <b-col lg="3">
      <b-card :no-body="true">
        <div class="card-body p-3 clearfix">
          <i class="fa fa-calculator bg-secondary font-2xl p-3 mr-3 float-left"></i>
          <div class="h5 mb-0 mt-2">{{ accounts.soldwtax | currency({fractionCount:0,symbolPosition:'back'}) }}</div>
          <div class="text-muted text-uppercase font-weight-bold font-xs">faturado últimos 30 dias com IVA</div>
        </div>
      </b-card>
    </b-col>
    <b-col lg="3">
      <b-card :no-body="true">
        <div class="card-body p-3 clearfix">
          <i v-if="accounts.open_variant==='success'" :class="'fa fa-check  p-3 font-2xl mr-3 float-left bg-'+accounts.open_variant"></i>
          <i v-if="accounts.open_variant!=='success'" :class="'fa fa-times  p-3 font-2xl mr-3 float-left bg-'+accounts.open_variant"></i>
          <div :class="'h5 mb-0 mt-2  text-'+accounts.open_variant">{{ accounts.open_value | currency }} <span class="small">({{ accounts.open_percent | currency({symbol:'%',fractionCount:0,symbolPosition:'back',symbolSpacing:false}) }})</span></div>
          <div class="text-muted text-uppercase font-weight-bold font-xs">Valor em aberto <span class="small">(max {{ accounts.open_objective | currency({symbol:'%',fractionCount:0,symbolPosition:'back',symbolSpacing:false}) }})</span></div>
        </div>
      </b-card>
    </b-col>
    <b-col lg="3">
      <b-card :no-body="true">
        <div class="card-body p-3 clearfix">
          <i v-if="accounts.expired_variant==='success'" :class="'fa fa-check  p-3 font-2xl mr-3 float-left bg-'+accounts.expired_variant"></i>
          <i v-if="accounts.expired_variant!=='success'" :class="'fa fa-times  p-3 font-2xl mr-3 float-left bg-'+accounts.expired_variant"></i>
          <div :class="'h5 mb-0 mt-2  text-'+accounts.expired_variant">{{ accounts.expired_value | currency }} <span class="small">({{ accounts.expired_percent | currency({symbol:'%',fractionCount:0,symbolPosition:'back',symbolSpacing:false}) }})</span></div>
          <div class="text-muted text-uppercase font-weight-bold font-xs">Valor vencido <span class="small">(max {{ accounts.expired_objective | currency({symbol:'%',fractionCount:0,symbolPosition:'back',symbolSpacing:false}) }})</span></div>
        </div>
      </b-card>
    </b-col>
  </b-row>


  <b-row>
    <b-col sm="12" lg="6" v-if="$auth.check(['dashboard.objectives'])">
      <b-card no-body>
        <b-card-header>
          Litros por LE
          <span class="float-right"><b-form-select v-model="selectedMonthLitersLE" :options="monthOptions" class="" size="sm" /></span>
        </b-card-header>
        <objectives-table :items="litersLE" :fields="objectiveFieldsLE" table-caption="" symbol=""></objectives-table>
      </b-card>
    </b-col>

    <b-col sm="6" v-if="$auth.check(['dashboard.effectiveness'])">
      <b-card no-body>
        <b-card-header>
          Efetividade de visitas
          <span class="float-right">últimos 30 dias</span>
        </b-card-header>
        <EffectivenessTable :fields="effectivenessFields" :items="effectiveness" :per-page="0"></EffectivenessTable>

      </b-card>
    </b-col>

  </b-row>
  <b-row  v-if="$auth.check(['dashboard.last_updated'])" >

    <b-col sm="12">
      <b-card no-body>
        <b-card-header>
          Últimas atualizações
        </b-card-header>
        <b-row>
          <b-col sm="4" v-for="(item, index) in lastUpdate" :key="index">
            <div class="p-2">
              <strong>{{ item.tablename }}</strong>: {{ $moment(item.last_update).calendar() }}
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

  </b-row>

</div>
</template>

<script>
import ObjectivesTable from './dashboard/ObjectivesTable'
import EffectivenessTable from './dashboard/EffectivenessTable'
export default {
  name: 'dashboard',
  components: {
    ObjectivesTable,
    EffectivenessTable
  },
  data: function() {
    return {
      lastUpdate: [],
      mpgObjectives: {
        liters: [],
        gsv: [],
        operators6: [],
        operators3: [],
        operators: []
      },
      objectivesPeriods: [{
        value: 1,
        text: 'mês'
      }, {
        value: 2,
        text: 'acumulado até'
      }],
      selectedMonth: null,
      zone: null,
      selectedPeriod: 1,
      selectedMonthLitersLE: null,
      effectiveness: [],
      litersLE: [],
      accounts: {
        open_docs: 0,
        expired_docs: 0,
        avg_expired_docs: 0,
        days_behind: 0,
        open_value: 0,
        expired_value: 0
      },
      monthOptions: [],
      objectivesZones: [],
      effectivenessCurrentPage: 1,
      effectivenessFields: [
        { key: 'team', label: 'Vendedor', sortable: true },
        { key: 'visits', label: 'Visitas', sortable: true },
        { key: 'sales', label: 'Encomendas', sortable: true },
        { key: 'effectiveness', label: 'Efetividade', sortable: true }
      ],
      objectiveFields: [
        { key: 'name', label: 'Gama', sortable: true },
        { key: 'objective_value', label: 'Objectivo', sortable: true },
        { key: 'current', label: 'Realizado', sortable: true },
        { key: 'progress', label: 'Progresso', sortable: true }
      ],
      objectiveFieldsWithBalance: [
        { key: 'name', label: 'Gama', sortable: true },
        { key: 'objective_value', label: 'Objectivo', sortable: true },
        { key: 'current', label: 'Realizado', sortable: true },
        { key: 'progress', label: 'Progresso', sortable: true },
        { key: 'balance', label: 'Saldo', sortable: true }
      ],
      objectiveFieldsWithQT: [
        { key: 'name', label: 'Gama', sortable: true },
        { key: 'objective_value', label: 'Objectivo', sortable: true },
        { key: 'current', label: 'Realizado', sortable: true },
        { key: 'progress', label: 'Progresso', sortable: true },
        { key: 'remaining', label: 'QT', sortable: true }
      ],
      objectiveFieldsLE: [
        { key: 'name', label: 'Gama', sortable: true },
        { key: 'objective_value', label: 'Homólogo', sortable: true },
        { key: 'current', label: 'Realizado', sortable: true },
        { key: 'progress', label: 'Progresso', sortable: true }
      ],
      tableFields: {
        tablename: {
          label: 'Tabela'
        },
        last_update: {
          label: 'Última atualização'
        }
      }
    }
  },
  watch: {
    zone: {
      handler: function(zone) {
        var p = this.selectedPeriod
        var m = this.selectedMonth
        console.log('period', p)
        this.loadObjectives('liters', p, m, zone)
        this.loadObjectives('gsv', p, m, zone)
        this.loadObjectives('operators', p, m, zone)
        this.loadObjectives('operators3', p, m, zone)
        this.loadObjectives('operators6', p, m, zone)
      }
    },
    selectedMonth: {
      handler: function(newValue) {
        var p = this.selectedPeriod
        var zone = this.zone
        console.log('period', p)
        this.loadObjectives('liters', p, newValue, zone)
        this.loadObjectives('gsv', p, newValue, zone)
        this.loadObjectives('operators', p, newValue, zone)
        this.loadObjectives('operators3', p, newValue, zone)
        this.loadObjectives('operators6', p, newValue, zone)
      }
    },
    selectedPeriod: {
      handler: function(newValue) {
        var p = this.selectedMonth
        var zone = this.zone
        this.loadObjectives('liters', newValue, p, zone)
        this.loadObjectives('gsv', newValue, p, zone)
        this.loadObjectives('operators', newValue, p, zone)
        this.loadObjectives('operators3', newValue, p, zone)
        this.loadObjectives('operators6', newValue, p, zone)
      }
    },
    selectedMonthLitersLE: {
      handler: function(newValue) {
        this.loadLitersLE(newValue)
      }
    }
  },
  methods: {
    loadObjectives(objectiveType, period, dts, zone) {
      var data = {
        analysisType: period,
        columns: 'gsv',
        rows: 'products',
        subrows: 'mpg_id',
        groupby: 'none',
        presetdate: 'custom',
        datetype: 'y',
        year: dts.year,
        clientType: 'F',
        docType: 'AGR',
        dates: {
          start: {
            day: dts.start,
            month: dts.month
          },
          end: {
            day: dts.end,
            month: dts.month
          }
        },
        zone: zone
      }
      if (period === 2) {
        data.dates.start.day = 1
        data.dates.start.month = 1
      }
      console.log(period)
      this.axios.post('dashboard/mpg_objectives/' + objectiveType + '/' + dts.year_month, data).then(response => {
        this.mpgObjectives[objectiveType] = response.data.data
      })
    },
    loadLitersLE(dts) {
      var data = {
        columns: 'gsv',
        rows: 'products',
        subrows: 'mpg_id',
        groupby: 'none',
        presetdate: 'custom',
        datetype: 'y',
        year: dts.year,
        clientType: 'F',
        docType: 'AGR',
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: dts.end,
            month: dts.month
          }
        }
      }

      this.axios.post('dashboard/objectives/litersLE/' + dts.year_month, data).then(response => {
        this.litersLE = response.data.data
      })
    }
  },
  created() {
    console.log(this.$auth.check('dashboard.objectives'))
    this.axios.get('lastupdate').then(response => {
      this.lastUpdate = response.data.data
    })
    this.axios.get('dashboard/objectives').then(response => {
      this.monthOptions = response.data.data.months
      this.objectivesZones = response.data.data.zones
      this.zone = this.objectivesZones[0].value
      this.selectedMonth = this.monthOptions[1].value
      this.selectedMonthLitersLE = this.monthOptions[1].value
      // this.loadObjectives('liters')
      // this.loadObjectives('gsv')
      // this.loadObjectives('operators3')
    })
    this.axios.get('dashboard/objectives/accounts').then(response => {
      this.accounts = response.data.data
    })

    this.axios.get('dashboard/objectives/effectiveness').then(response => {
      this.effectiveness = response.data.data
    })
    // this.axios.post('dashboard/objectives/litersLE', data).then(response => {
    //   this.litersLE = response.data.data
    // })
  }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?6878d460